
import Axios from "axios";

import { apiUrl, serializeObjToGetStr } from "../../constants";

const productsBaseUrl = `${apiUrl}/products`;
const config = {
    headers: { "Content-Type": "application/json-patch+json" }
};

export const productApi = {
  getAll: request => {
    const query = serializeObjToGetStr(request);
    return Axios.get(`${productsBaseUrl}?${query}`);
  },
  getArchived: request => {
    const query = serializeObjToGetStr(request);
    return Axios.get(`${productsBaseUrl}/archived?${query}`);
  },
  save: product => {
    return Axios.post(productsBaseUrl, product, config);
  },
  delete: (id, newStatus?) => {
    const url = newStatus !== undefined
      ? `${productsBaseUrl}/${id}?newStatus=${newStatus}`
      : `${productsBaseUrl}/${id}`;
    return Axios.delete(url, config);
  },
    restore: (id) => {
      return Axios.post(`${productsBaseUrl}/${id}/restore`, {}, config);
    },
    updateDeleteStatus: (id, newStatus) => {
      return Axios.put(`${productsBaseUrl}/${id}/delete-status`, { newStatus }, config);
    },

};
